export default __webpack_public_path__ + "static/media/2.1f4f56b5.svg";